import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/pin";
import Loading from "@/atomic/atoms/Loading";
import Button from "@/atomic/atoms/Button";
import Modal from "@/atomic/atoms/Modal";
import { Suspense } from "react";

export default function RegisterPinView({
  timer,
  handleSubmit,
  isLoading,
  handleTryAgain,
  goBack,
  isDisabled,
  isVisibleModal,
  toggleModal,
  goToLogin,
  isEmail,
  register,
  errors,
  error,
}: PropsView) {
  return (
    <div className="h-full relative">
      <Header
        title="Validação"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div className="h-12">
            <h2 className="mt-6 text-black text-xl">Validar PIN</h2>
            <h3 className="text-black text-sm mt-2">Digite o código PIN enviado para o seu {isEmail ? "e-mail" : "celular"} cadastrado. O tempo de duração é de 15 minutos</h3>
            <div className="mt-6 flex flex-col justify-center items-center">
              <div>
                <InputMask 
                  {...register('pin')}
                  className={`w-[calc(260px)] tracking-[calc(20px)] text-black bg-transparent text-center h-7 text-2xl ${errors.pin && "text-red-600"}`} 
                  type="text" 
                  inputMode="numeric"
                  name="pin" 
                  placeholder="_____" 
                  mask="_____"
                  replacement={{ _: /\d/ }}
                />
                {(errors.pin || error) && <div className="flex item-center w-[calc(260px)] justify-center">
                  <img 
                    src={"/icon-error.png"}
                    width={16}
                    height={16}
                    alt="erro"
                    className="mr-1"
                  />
                  <p className="text-red-600 text-center text-xs">{errors?.pin?.message ?? "Pin inválido. Tente novamente"}</p>
                </div>}
              </div>
              <p className="text-black mt-6 text-left text-xs">
                Não recebeu o PIN por {isEmail ? "E-mail" : "SMS"}? Tente estas opções:
                <br/>- Verifique se o {isEmail ? "remetente" : "número"} do Pedágio Digital está bloqueado e, se necessário, desbloqueie.
                <br/>- Confirme se digitou o {isEmail ? "e-mail" : "número"} correto.
                {!isEmail && <><br/>- Confira se há sinal da sua operadora.</>}
                <br/>- Tente novamente.
              </p>
              <button type="button" className="text-black mt-6 text-base underline" onClick={handleTryAgain}>Reenviar código {timer !== 0 && "em 00:" + (timer < 10 ? "0" : "") + timer}</button>
            </div>
          </div>
          <Button 
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {isVisibleModal && <Suspense fallback={null}>
        <Modal 
          title="Atenção!"
          message="Já existe uma conta Pedágio Digital para esse CPF. Clique em Acessar conta e faça login com CPF e senha."
          actionMessage="Acessar conta"
          action={() => {
            toggleModal();
            goToLogin();
          }}
          hasCloseButton={false}
        />
      </Suspense>}
      {isLoading && <Suspense fallback={null}>
        <Loading />
      </Suspense>}
    </div>
  );
}
